import { FormProvider, useForm } from "react-hook-form";
import { twMerge } from "tailwind-merge";
import { Dialog } from "@shared/ui/Dialog";
import { Label } from "@shared/ui/Label";
import { OrgLookupInput } from "@shared/ui/OrgLookupInput";
import { useDialog } from "@shared/features/dialog/useDialog";
import { useOrgLookup } from "../../hooks/useOrgLookup";
import { OrgLookupItemContainer } from "../OrgLookupItem/OrgLookupItemContainer";

export function OrgLookupDialog() {
  const { activeDialog, closeDialog } = useDialog();

  const isOpen = activeDialog === "orgLookup";

  const {
    handleClose,
    handleSelectOrganization,
    handleCreateOrganization,
    options,
    selectedOptions,
    selectedOrg,
    isLoading,
  } = useOrgLookup({
    onClose: () => closeDialog("orgLookup"),
    shouldLoad: isOpen,
  });

  const form = useForm();

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      title="No invite code?"
      description="We accept alumni from vetted cross-disciplinary institutions and programs."
      isWithActions={false}
    >
      <FormProvider {...form}>
        <div
          className={twMerge(
            "flex flex-col gap-8",
            selectedOptions.length === 0 ? "mb-40" : "mb-8"
          )}
        >
          <OrgLookupInput
            name="organization"
            onSelect={handleSelectOrganization}
            onCreate={handleCreateOrganization}
            options={options}
            value={selectedOrg}
            isLoading={isLoading}
            className="px-0"
          />
          {selectedOptions.length > 0 && (
            <div className="flex flex-col gap-2">
              <Label>Selected Organizations</Label>
              <div className="flex flex-col gap-2">
                {selectedOptions.map((option) => (
                  <OrgLookupItemContainer key={option.value} {...option} />
                ))}
              </div>
            </div>
          )}
        </div>
      </FormProvider>
    </Dialog>
  );
}

export default OrgLookupDialog;
``;
